<template>
  <div v-if="showWidget" class="activity-widget" @click="openCustomerService">
    <img :src="$fixAssetUrl(ACTIVITY_IMAGE_PATH)" class="activity-img" alt="活动" />
    <div class="close-btn-zone" @click.stop="closeActivityWidget">
      <img :src="$fixAssetUrl('/images/activity/close.png')" class="close-btn" alt="关闭" />
    </div>
  </div>
</template>

<script setup>
// 客服行为统一在 CustomerService 中维护，页面只绑定咨询事件。
import { openCustomerService } from '@/utils/CustomerService'
import { ref, onMounted } from 'vue'

const ACTIVITY_IMAGE_PATH = '/img/v2/components/2026/qjb/suspension.png'
/** 德语、法语、西语、俄语站点显示 */
const VISIBLE_PROFILES = ['de', 'fr', 'es', 'ru']

/**
 * 活动组件显示状态
 */
const showWidget = ref(false)


/**
 * 关闭活动组件
 */
const closeActivityWidget = () => {
  showWidget.value = false
}

onMounted(() => {
  const currentProfile = typeof __SITE_PROFILE__ !== 'undefined' ? __SITE_PROFILE__ : 'de'

  // 活动时间：2026.09.01 - 2026.09.30（北京时间，9月30日当天有效）
  const startTime = new Date('2026-09-01T00:00:00+08:00').getTime()
  const endTime = new Date('2026-10-01T00:00:00+08:00').getTime()
  const now = Date.now()
  const isActivityActive = now >= startTime && now < endTime

  if (VISIBLE_PROFILES.includes(currentProfile) && isActivityActive) {
    showWidget.value = true
  }
})
</script>

<style scoped lang="scss">
.activity-widget {
  margin-top: calc(20 / 375 * 100vw);
  margin-right: calc(3 / 375 * 100vw);
  position: relative;
  width: calc(64 / 375 * 100vw);
  height: calc(64 / 375 * 100vw);
  cursor: pointer;
  
  .activity-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  .close-btn-zone {
    position: absolute;
    top: calc(-5 / 375 * 100vw);
    right: calc(-5 / 375 * 100vw);
    padding: calc(5 / 375 * 100vw);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    
    .close-btn {
      width: calc(13 / 375 * 100vw);
      height: calc(13 / 375 * 100vw);
    }
  }
}
</style>
